// Canonical bot-difficulty surface. The full difficulty bar (Recruit, Tactical,
// Commander) is documented in docs/07_BOT_AI.md; V1.5 lights up the Commander
// tier on top of Recruit + Tactical. Recruit is the default — Tactical crushes
// new RTS players on a first-match loss (CrazyGames stats), so the gentlest
// tier is the safer baseline; returning players can climb from the menu.
//
// Difficulty modulates ONLY reaction delay (and a slight tightening of triggers
// at the top tier) — never perfect-information, supernatural reflexes, or cheats
// (docs/07_BOT_AI.md §Difficulties). The host wires the selected difficulty into
// the right BotPlayer subclass via HostFactory.

export type BotDifficulty = 'recruit' | 'tactical' | 'commander';

export interface BotConfig {
  difficulty: BotDifficulty;
}

export const DEFAULT_BOT_DIFFICULTY: BotDifficulty = 'recruit';
